import UserIcon from "../../assets/img/user-icon.svg";
import ExchangeIcon from "../../assets/img/exchange-icon.svg";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import useTranslator from "../../hooks/useTranslator";
import { useLocation, useNavigate } from "react-router-dom";
import { haveValue } from "../../helper/common";
const EarnerCard = ({
  handleUpdateSource,
  userData,
  type,
  setUpdateSourceObj,
  allowViewProfile = true,
  showReportIcons,
  user,
  onClose = () => {},
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const location = useLocation();

  const checkGuarantorProfile = (guarantor_id) => {
    console.log("guarantor_id", guarantor_id);
    const usertype = localStorage.getItem("usertype");
    const fullPath = location.pathname + location.search;
    if (usertype == "landlord") {
      navigate(`${fullPath}&guarantor=${guarantor_id}`);
    }
  };

  const handleChangeSource = () => {
    handleUpdateSource();
    setUpdateSourceObj({
      _id: userData?.all_sources?._id,
      all_sources: userData?.all_sources,
      current_selected: userData?.source,
      type,
    });
  };
  return (
    <div className="earner-card mb-3">
      <div className="earner-info align-items-center justify-content-between gap-2 d-flex">
        <div className="align-items-center gap-2 d-flex">
          <div className="earner-thumbnail-wrapper">
            <img src={UserIcon} alt="User Icon" />
          </div>
          <h4 className="earner-name">
            {haveValue(userData?.all_sources?.name)
              ? userData?.all_sources?.name
              : type === "tenant" && haveValue(user)
              ? `${user?.fname ?? ""} ${user?.lname ?? ""}`
              : ""}
          </h4>
          <span className="earner-role">{_t(type)}</span>
        </div>
        {allowViewProfile && showReportIcons && (
          <div
            className="viewMorebtn cursor-pointer"
            onClick={() => {
              onClose();
              checkGuarantorProfile(userData?.all_sources?._id);
            }}
          >
            <p>{_t("View More")}</p>
            <KeyboardArrowRightOutlinedIcon className="btnSv" />
          </div>
        )}
      </div>
      <div className="income-source-wrapper">
        <div className="income-source-main">
          <div className="income-source">
            <p>
              {_t("incomeSource")}: <span>{_t(userData?.source)}</span>
            </p>
          </div>
          {showReportIcons && haveValue(userData?.all_sources) && (
            <div className="re-do-icon-wrapper">
              <img
                src={ExchangeIcon}
                alt=""
                onClick={handleChangeSource}
                style={{ cursor: "pointer" }}
              />
            </div>
          )}
        </div>
        <h4 className="earning">€{userData?.amount}</h4>
      </div>
    </div>
  );
};

export default EarnerCard;
